import Guide0 from "./pages/guide/guide0"
import Guide1 from "./pages/guide/guide1"
import Guide2 from "./pages/guide/guide2"
import Guide3 from "./pages/guide/guide3"
import Guide4 from "./pages/guide/guide4"
import Guide5 from "./pages/guide/guide5"
import Guide5Loading from "./pages/guide/guide5_loading"
import Guide6 from "./pages/guide/guide6"
import Guide7 from "./pages/guide/guide7"
import Guide8 from "./pages/guide/guide8"
import Guide9 from "./pages/guide/guide9"
import Guide10 from "./pages/guide/guide10"

const routes = [
    {
        exact: true,
        path: "/",
        component: Guide0
    },
    {        
        path: "/guide1",
        component: Guide1
    },
    {
        path: '/guide2',
        component: Guide2
    },
    {
        path: '/guide3',
        component: Guide3
    },
    {
        path: '/guide4',
        component: Guide4
    },
    {
        exact: true,
        path: '/guide5',
        component: Guide5
    },
    {
        path: '/guide5loading',
        component: Guide5Loading
        
    },
    {
        path: '/guide6',
        component: Guide6
    },
    {
        path: '/guide7',
        component: Guide7
    },
    {
        path: '/guide8',
        component: Guide8
    },
    {
        path: '/guide9',
        component: Guide9
    },
    {
        path: '/guide10',
        component: Guide10 
    }


];
export default routes
